import { Group, Stack, Text } from "@mantine/core"
import { CountryLabel } from "@tfg/ui"

import { useListSupplierProductionSitesQuery } from "~/pages/SupplierPortal/ProductionSites/hooks/useListProductionSiteQuery.ts"
import { COUNTRIES } from "~/utils/countries.ts"

export function ProductionSiteDisplay({
  productionSiteId,
}: {
  productionSiteId: string | undefined | null
}) {
  const productionSites = useListSupplierProductionSitesQuery().data
  const productionSite = productionSites?.find(
    (ps) => ps.id === productionSiteId
  )
  if (!productionSite) return null
  return (
    <Group justify="space-between">
      {productionSite ? (
        <Stack gap={0}>
          <Text fw={700}>{productionSite.name}</Text>
          {productionSite.country && (
            <Group gap="xs">
              <CountryLabel
                countryIso3166={productionSite.country}
                width={12}
                countriesMapper={COUNTRIES}
              />
              <Text size="xs">{productionSite.address}</Text>
            </Group>
          )}
        </Stack>
      ) : null}
    </Group>
  )
}
